import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
} from "@mui/material";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const SessionTimeoutDialog = ({ open, countdown, onLogout, onContinue }) => {
  return (
    <Dialog
      open={open}
      className="session-timeout"
      TransitionComponent={Transition}
    >
      <DialogTitle>Session Timeout</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          The current session is about to expire in <span>{countdown}</span>{" "}
          seconds due to inactivity.
        </Typography>
        <Typography variant="body2">{`Would you like to continue the session?`}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} className="reset-opt">
          Logout
        </Button>
        <Button onClick={onContinue} className="market-btn">
          Continue Session
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SessionTimeoutDialog;
